import gql from 'graphql-tag'

export const mutation = gql`
  mutation updateFinancialAccount($id: Int!, $fields: finance_financial_account_set_input!) {
    record: update_finance_financial_account_by_pk(pk_columns: {id: $id}, _set: $fields) {
      id
    }
  }
`

export default mutation
